import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import BoardOfDirectors from './pages/BoardOfDirectors/BoardOfDirectors';
import Products from './pages/Products/Products';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import InvestorRelations from './pages/InvestorRelations/InvestorRelations';
import InvestorProjectDetail from './pages/InvestorProjectDetail/InvestorProjectDetail';
import OurFactory from './pages/OurFactory/OurFactory';
import SuccessPartners from './pages/SuccessPartners/SuccessPartners';
import MediaCenter from './pages/MediaCenter/MediaCenter';
import Gallery from './pages/Gallery/Gallery';
import NewsDetail from './pages/NewsDetail/NewsDetail';
import ContactUs from './pages/ContactUs/ContactUs';
import styles from './App.module.css';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <Router>
      <div className={styles.app}>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/board-of-directors" element={<BoardOfDirectors />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/investor-relations" element={<InvestorRelations />} />
          <Route path="/investor-relations/project/:slug" element={<InvestorProjectDetail />} />
          <Route path="/our-factory" element={<OurFactory />} />
          <Route path="/success-partners" element={<SuccessPartners />} />
          <Route path="/media-center" element={<MediaCenter />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

